import styled, { css } from 'styled-components';

import type { WithChildren } from '@/lib/types';
import { px2rem } from '@/theme';

const StyledList = styled.ul`
  &&& {
    padding-bottom: ${({ theme }) => theme.spacing(1)};
    margin-left: ${({ theme }) => theme.spacing(1)};

    li {
      position: relative;
      margin-left: 0;
      display: flex;
      align-items: baseline;
      text-align: left;
      span,
      p,
      a {
        padding: 0;
      }

      p {
        padding-bottom: ${({ theme }) => theme.spacing(1)};
      }

      &:last-child {
        padding: 0;
      }
      &::before {
        content: '\\2022';
        ${({ theme }) => css`
          top: ${theme.spacing(1)};
          margin-inline: ${px2rem(5, 10)};
        `}
      }
    }
  }
`;

export const List = ({ children }: WithChildren) => (
  <StyledList>{children}</StyledList>
);
